import React from 'react';
import styled from 'styled-components';
import { media, theme } from '@marketing-site/styles';
import { Divider, Link, Paper, Stack, Typography } from '@mui/material';
import { Job } from '@marketing-site/api/careers/apiSlice';
import { Listing } from './Listing';

export type JobsTableProps = {
  jobs: Job[];
};

export type JobsByDepartment = {
  [departmentName: string]: Job[];
};

export const JobsTable = ({ jobs }: JobsTableProps) => {
  const groupedJobs = jobs?.reduce((acc: JobsByDepartment, job: Job) => {
    const dept = job.department;
    if (!acc[dept]) {
      acc[dept] = [];
    }
    acc[dept].push(job);
    return acc;
  }, {});

  return (
    <>
      {groupedJobs &&
        Object.keys(groupedJobs).map((key, index) => (
          <Stack gap={'16px'} key={`${key}-${index}`}>
            <Typography
              fontSize={'16px'}
              fontWeight={400}
              lineHeight={1.5}
              color={'#606060'}
            >
              {key}
            </Typography>
            <Divider sx={{ opacity: 1, color: '#E7E7E7' }} />
            {groupedJobs[key].map((job, index) => {
              return <Listing job={job} key={`${key}-${job}-${index}`} />;
            })}
          </Stack>
        ))}
    </>
  );
};
